import { render, staticRenderFns } from "./table1.vue?vue&type=template&id=0d32c58b&scoped=true"
import script from "./table1.vue?vue&type=script&lang=js"
export * from "./table1.vue?vue&type=script&lang=js"
import style0 from "./table1.vue?vue&type=style&index=0&id=0d32c58b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d32c58b",
  null
  
)

export default component.exports